import { required } from "vuelidate/lib/validators";

export default {
  login: {
    username: { required },
    password: { required }
  }
};
